import { render } from "./Home.vue?vue&type=template&id=5f966705&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=5f966705&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\TECHNOVA_FD01\\Desktop\\Augustine\\Projects\\XP\\payout-fe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f966705"]])

export default __exports__